__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/62740e727b406c7c2497ed3ef528d445556902e1cf6ffad8a25d6748/";